import { Panel } from "./shared";

export const RotatePanel = ({ angle, onChange, activePicker }) => (
  <Panel>
    <div className="grid grid-cols-3 gap-1 p-1 bg-page border border-hairline rounded-lg" data-testid="rotate-angle-picker">
      {[90, 180, 270].map((a) => (
        <button key={a} data-testid={`rotate-angle-${a}`} onClick={() => onChange(a)}
          className={`py-2 min-h-[44px] rounded-full font-mono text-xs transition-colors duration-300 ${angle === a ? activePicker : "text-fog hover:text-ink"}`}>
          {a}°
        </button>
      ))}
    </div>
  </Panel>
);
